import React, { Component } from "react";
import {
  message,
  Modal,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  Checkbox,
  notification,
  Space,
  Upload,
  Switch,
  Typography,
  Tag,
  Tooltip,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  round2Decimals,
  ModalItem,
  ButtonItem,
  InputItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  round6Decimals,
  ErrorItem,
  round4Decimals,
  SelectInsumosItem,
  DisponibilidadInsumoModal,
  calcularAjusteAutomaticoFactura
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import {
  PlusOutlined,
  SplitCellsOutlined,
  UploadOutlined,
  CarOutlined,
  EnvironmentOutlined,
  PhoneFilled,
  InfoCircleOutlined,
  UserOutlined,
  DeleteOutlined,
  DatabaseOutlined,
  TagsOutlined,
  ToolOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import xmlToJson from "../../../../Components/xmlToJson";
import ModalDiagnosticoCuadre from "../../../../Components/ModalDiagnosticoCuadre";
import {
  leerCfdiParaDiagnostico,
  construirCapturadoDesdeTotales,
  diagnosticarCuadreFactura,
} from "../../../../Utils/diagnosticoCuadreFactura";
import ElegirTipoDeProveedor from "../../Proveedores/ElegirTipoDeProveedor/ElegirTipoDeProveedor";
import AgregarMarbetes from "../../Marbetes/AgregarMarbetes/AgregarMarbetes";
import decodeHTMLEntities from "../../../../Components/decodeHtmlEntities";
import AgregarLotes from "../../LotesCaducidades/AgregarLotes/AgregarLotes";
import AgregarUnidadesActivo from "../../ActivosFijos/AgregarUnidadesActivo/AgregarUnidadesActivo";
import ModalEtiquetasActivosFijos from "../../InventarioActivos/ModalEtiquetasActivosFijos/ModalEtiquetasActivosFijos";
import InsumoDetalleRow from "../../../../Components/InsumoDetalleRow";
import { esUuidSat } from "../../../../Utils/uuidFactura";
import { avisarRegimenYObjetoImpXml } from "../../../../Utils/avisosFiscalesXmlRecibido";
import ModalSplitInsumo from "../../FacturasSinOrdenDeCompra/ModalSplitPartida/ModalSplitPartida";

const { Option } = Select;

moment.locale("es");

function calcularTotalesInsumo(insumoRow, proveedor) {
  const insumo = insumoRow.insumoCompleto;
  if (!insumo) return insumoRow;

  const precioUnitario = Number(insumoRow.precioUnitario || 0);
  const cantidad = insumoRow.cantidad;
  const descuento = insumoRow.descuento || 0;

  let totalImpuestosPrecioSinImpuestos = 0;
  for (const imp of insumo.impuestos) {
    let t = 0;
    if (imp.tasaCuota === 1) t = precioUnitario * (imp.monto / 100);
    else if (imp.tasaCuota === 2) t = (precioUnitario + totalImpuestosPrecioSinImpuestos) * (imp.monto / 100);
    else if (imp.tasaCuota === 3) t = imp.monto;
    else if (imp.tasaCuota === 4) t = cantidad ? (insumoRow.impuestos || 0) / cantidad : 0;
    // tasaCuota 5 = 0
    totalImpuestosPrecioSinImpuestos += t;
  }
  const precioUnitarioConImpuestos = round2Decimals(precioUnitario + totalImpuestosPrecioSinImpuestos);

  if (!((precioUnitario || precioUnitario === 0) && cantidad)) {
    return { ...insumoRow, precioUnitarioConImpuestos };
  }

  const subtotalBruto = round6Decimals(cantidad * precioUnitario);
  const totalDescuento = round6Decimals(subtotalBruto * (descuento / 100));
  const totalEntrada = round6Decimals(subtotalBruto - totalDescuento);

  let totalImpuestos = 0;
  const arrayImpuestos = insumo.impuestos.map((imp) => {
    let t = 0;
    if (imp.tasaCuota === 1) t = round6Decimals(totalEntrada * (imp.monto / 100));
    else if (imp.tasaCuota === 2) t = round6Decimals((totalEntrada + totalImpuestos) * (imp.monto / 100));
    else if (imp.tasaCuota === 3) t = round6Decimals(cantidad * imp.monto);
    else if (imp.tasaCuota === 4) t = round6Decimals(insumoRow.impuestos || 0);
    // tasaCuota 5 = 0
    totalImpuestos += t;
    return { descripcionFactura: imp.descripcionFactura, totalImpuestos: t };
  });

  const total = round2Decimals(totalEntrada + totalImpuestos);

  // Retenciones
  let totalRetenciones = 0;
  const arrayRetenciones = [];

  if (proveedor) {
    const procesarRetencion = (ret, condicion = true) => {
      if (!condicion) return;
      let t = 0;
      if (ret.tasaCuota === 1) t = round6Decimals(totalEntrada * (ret.monto / 100));
      else if (ret.tasaCuota === 2) t = round6Decimals((totalEntrada + totalRetenciones) * (ret.monto / 100));
      totalRetenciones += t;
      arrayRetenciones.push({ descripcionFactura: ret.descripcionFactura, totalRetenciones: t });
    };

    for (const ret of (proveedor.retenciones || [])) {
      procesarRetencion(ret);
    }
    for (const ret of (insumo.retenciones || [])) {
      const aplica =
        (ret.aplicaCompra === 1 && !proveedor.persona) ||
        (ret.aplicaCompra === 2 && proveedor.persona) ||
        ret.aplicaCompra === 3;
      procesarRetencion(ret, aplica);
    }
  }

  return {
    ...insumoRow,
    precioUnitarioConImpuestos,
    subtotal: totalEntrada,
    impuestos: totalImpuestos,
    arrayImpuestos,
    total,
    retenciones: totalRetenciones,
    arrayRetenciones,
  };
}

class AgregarFacturaCajaChica extends Component {
  formRef = React.createRef();
  state = {
    modalDisponibilidadVisible: false,
    insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    //todasInsumos: [],
    objetoCajaChica: null,
    todasCajaChica: null,
    objetoFormasDePago: null,
    todasFormasDePago: null,
    impuestos: [],
    modalConfirmacion: false,
    valuesForm: null,
    modalElegirTipoDeProveedor: false,
    modalElegirTipoDeProveedorId: null,
    modalElegirTipoDeProveedorNombre: null,
    archivosXml: [],
    empresaRfc: null,
    ajusteMax: 0,
    modalAgregarMarbetes: false,
    modalAgregarMarbetesIndex: null,
    modalAgregarMarbetesMarbetes: null,
    estadoCC: false,
    estadoDespensa: false,
    prorrateoDesCostos: false,
    xmlFile: null,
    // El resto del archivo lee y escribe `xmltotales` en minusculas; la llave con mayuscula
    // quedaba muerta y el setState la creaba al vuelo.
    xmltotales: null,
    // Desglose completo del CFDI (conceptos, traslados, retenciones, implocal) para el
    // diagnostico de cuadre. xmltotales solo guarda SubTotal y Total.
    xmlDiagnostico: null,
    modalDiagnosticoVisible: false,
    diagnostico: null,
    ajusteContexto: null,
    mensajeMostrado: false,
    modalAgregarLotes: false,
    modalAgregarLotesIndex: null,
    modalAgregarLotesLotes: null,
    modalAgregarLotesVehiculo: false,
    modalAgregarLotesInsumoId : null,
    modalAgregarUnidadesActivo: false,
    modalAgregarUnidadesActivoIndex: null,
    modalAgregarUnidadesActivoUnidades: null,
    modalAgregarUnidadesActivoCantidad: 0,
    modalAgregarUnidadesActivoInsumo: null,
    modalEtiquetasActivosVisible: false,
    entradaSalidaIdsEtiquetas: [],
    codigoFacturaCreada: null,
    mostrarDetalles: true,
    objetoUsosDeCFDI: null,
    todasUsosDeCFDI: null,
    uuidDuplicado: false,
    mensajeUuidDuplicado: undefined,
  };
  async componentDidMount() {
    this.setState({ loading: true });
    await this.consultarTodo();
    if (this.props?.location?.state) {
      this.leerXmlData(this.props.location.state);
    }
    this.setState({ loading: false });
  }

  abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
    this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
  };

  cerrarDisponibilidad = () => {
    this.setState({ modalDisponibilidadVisible: false });
  };

  promisedSetState = (newState) =>
    new Promise((resolve) => this.setState(newState, resolve));

  async consultarTodo() {
    const response = await axios.post(
      "facturasCajaChica/selectDatosParaFacturaCajaChica",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    const data = response.data;
    let newState = {};

    if (!data.configuracion || data.configuracion.status === 404) {
      message.error("Error no se encontro configuracion de esta empresa");
    } else {
      newState.empresaRfc = data.configuracion.rfc;
      newState.ajusteMax = data.configuracion.ajusteMax;
      newState.prorrateoDesCostos = !!data.configuracion.prorrateoDesCostos;
    }

    if (data.proveedores?.length > 0) {
      newState.todasProveedores = data.proveedores;
      newState.objetoProveedores = data.proveedores.map((value) => (
        <Option value={value._id} key={value._id}>{value.stringBuscar}</Option>
      ));
    }

    if (data.proyectos?.length > 0) {
      newState.todasProyectos = data.proyectos;
      newState.objetoProyectos = data.proyectos.map((value) => (
        <Option value={value._id} key={value._id}>{value.nombre}</Option>
      ));
    }

    if (data.cajasChicas?.length > 0) {
      newState.todasCajaChica = data.cajasChicas;
      newState.objetoCajaChica = data.cajasChicas.map((value) => (
        <Option value={value._id} key={value._id}>
          {value.nombre + (value.banco ? " - " + value.banco : "")}
        </Option>
      ));
    }

    if (data.monedas?.length > 0) {
      newState.todasMonedas = data.monedas;
      newState.objetoMonedas = data.monedas.map((value) => (
        <Option value={value._id} key={value._id}>
          {value.nombre + " - " + value.abreviacion}
        </Option>
      ));
    }

    if (data.formasDePago?.length > 0) {
      newState.todasFormasDePago = data.formasDePago;
      newState.objetoFormasDePago = data.formasDePago.map((value) => (
        <Option value={value._id} key={value._id}>
          {value.c_FormaPago + " - " + value.descripcion}
        </Option>
      ));
    }

    if (data.usosDeCFDI?.length > 0) {
      newState.todasUsosDeCFDI = data.usosDeCFDI;
      newState.objetoUsosDeCFDI = data.usosDeCFDI.map((value) => (
        <Option value={value._id} key={value._id}>
          {value.c_UsoCFDI + " - " + value.descripcion}
        </Option>
      ));
    }

    await this.promisedSetState(newState);
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (this.state.uuidDuplicado) {
      return message.error(
        this.state.mensajeUuidDuplicado ||
        "No se puede registrar: la factura ya existe en el sistema"
      );
    }
    this.setState({ loading: true });
    let insumos = values.insumos;
    let total = 0;
    let subtotal = 0;
    let arrayImpuestos = [];
    let arrayRetenciones = [];
    let cuentasProveedor = 0;
    insumos.map((value) => {
      total += value.subtotal;
      subtotal += value.subtotal;
      value.arrayImpuestos.map((valueImpuestos) => {
        let index = arrayImpuestos.findIndex(
          (valueImpuestosAnterios) =>
            valueImpuestosAnterios.descripcionFactura ===
            valueImpuestos.descripcionFactura
        );
        if (index !== -1) {
          let newItem = {
            totalImpuestos:
              arrayImpuestos[index].totalImpuestos +
              valueImpuestos.totalImpuestos,
            descripcionFactura: valueImpuestos.descripcionFactura,
          };
          arrayImpuestos.splice(index, 1, newItem);
        } else {
          arrayImpuestos.push({
            totalImpuestos: valueImpuestos.totalImpuestos,
            descripcionFactura: valueImpuestos.descripcionFactura,
          });
        }
        return null;
      });
      if (value.arrayRetenciones) {
        value.arrayRetenciones.map((valueRetenciones) => {
          let index = arrayRetenciones.findIndex(
            (valueRetencionesAnterios) =>
              valueRetencionesAnterios.descripcionFactura ===
              valueRetenciones.descripcionFactura
          );
          cuentasProveedor += round2Decimals(valueRetenciones.totalRetenciones);
          if (index !== -1) {
            let newItem = {
              totalRetenciones:
                arrayRetenciones[index].totalRetenciones +
                valueRetenciones.totalRetenciones,
              descripcionFactura: valueRetenciones.descripcionFactura,
            };
            arrayRetenciones.splice(index, 1, newItem);
          } else {
            arrayRetenciones.push({
              totalRetenciones: valueRetenciones.totalRetenciones,
              descripcionFactura: valueRetenciones.descripcionFactura,
            });
          }
          return null;
        });
      }
      return null;
    });
    subtotal += values.ajusteSubtotal;
    total += values.ajusteSubtotal;
    arrayImpuestos = arrayImpuestos.map((valueImpuesto) => {
      let ajusteImpuesto = values["ajuste" + valueImpuesto.descripcionFactura] || 0;
      total += round2Decimals(valueImpuesto.totalImpuestos + ajusteImpuesto);
      return {
        ...valueImpuesto,
        ajusteImpuesto,
        totalImpuestos: round2Decimals(
          valueImpuesto.totalImpuestos + ajusteImpuesto
        ),
      };
    });
    arrayRetenciones = arrayRetenciones.map((valueRetencion) => {
      let ajusteRetencion =
        values["ajuste" + valueRetencion.descripcionFactura] || 0;
      cuentasProveedor += ajusteRetencion;
      return {
        ...valueRetencion,
        ajusteRetencion,
        totalRetenciones: valueRetencion.totalRetenciones + ajusteRetencion,
      };
    });
    if (
      round2Decimals(
        round2Decimals(this.state?.xmltotales?.Total || 0) - round2Decimals(total - cuentasProveedor)
      ) !== 0 &&
      this.state.xmltotales &&
      !this.state.estadoCC &&
      !this.state.estadoDespensa
    ) {
      this.setState({ loading: false });
      return message.error(
        'El total de la factura no coincide con el total del XML. Usa el botón "¿Por qué no cuadra?" junto a los totales para ver el detalle.'
      );
    }
    axios
      .post(
        "facturascajachica/agregarFactura",
        {
          ...values,
          empresaId: this.props.empresaId,
          total: round2Decimals(total),
          subtotal: round2Decimals(subtotal),
          cuentasProveedor: round2Decimals(cuentasProveedor),
          totalPagar: round2Decimals(total - cuentasProveedor),
          estadoCC: this.state.estadoCC,
          arrayImpuestos,
          arrayRetenciones,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado una factura");
          NotificacionPolizas(res.data.polizasId);
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.formRef.current.resetFields();
          // Unidades de activo fijo recien creadas: se ofrece imprimir sus
          // etiquetas antes de salir de la pantalla.
          const entradasActivo = res.data.entradasActivoFijoIds;
          if (Array.isArray(entradasActivo) && entradasActivo.length > 0) {
            this.setState({
              modalEtiquetasActivosVisible: true,
              entradaSalidaIdsEtiquetas: entradasActivo,
              codigoFacturaCreada: res.data.codigo,
            });
          } else {
            this.atras(res.data.codigo);
          }
        } else if (res.data.success === 1) {
          message.warning(res.data.message);
        } else {
          message.error("Hubo un error y la factura no se registro");
        }
      });
  }

  async onChangeInsumo(value, key, insumoSeleccionado) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    const insumo = insumoSeleccionado;

    if (!insumo) return;
    arrayValue[key].insumoCompleto = insumo;
    arrayValue[key].precioUnitario = insumo.costo;

    const precioUnitario = Number(arrayValue[key].precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    insumo.impuestos.map((valueImpuesto) => {
      let totalImpuesto;
      if (valueImpuesto.tasaCuota === 1) {
        totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 2) {
        totalImpuesto =
          (precioUnitario + totalImpuestosPrecioSinImpuestos) *
          (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 3) {
        totalImpuesto = valueImpuesto.monto;
      } else if (valueImpuesto.tasaCuota === 4) {
        let cantidad = arrayValue[key].cantidad;
        if (cantidad) {
          totalImpuesto =
            (arrayValue[key].impuestos || 0) / arrayValue[key].cantidad;
        }
      } else if (valueImpuesto.tasaCuota === 5) {
        totalImpuesto = 0;
      }
      totalImpuestosPrecioSinImpuestos += totalImpuesto;
      return null;
    });
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
      precioUnitario + totalImpuestosPrecioSinImpuestos
    );

    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        insumo.retenciones.map((valueRetencion) => {
          if (
            (valueRetencion.aplicaCompra === 1 &&
              proveedor.persona === false) ||
            (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) ||
            valueRetencion.aplicaCompra === 3
          ) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(
                totalEntrada * (valueRetencion.monto / 100)
              );
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion = round6Decimals(
                (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
              );
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null;
        });
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }

    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  async onChangePrecioCantidadDescuento(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    const insumo = arrayValue[key]?.insumoCompleto;
    if (!insumo) return;
    const precioUnitario = Number(arrayValue[key].precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    insumo.impuestos.map((valueImpuesto) => {
      let totalImpuesto;
      if (valueImpuesto.tasaCuota === 1) {
        totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 2) {
        totalImpuesto =
          (precioUnitario + totalImpuestosPrecioSinImpuestos) *
          (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 3) {
        totalImpuesto = valueImpuesto.monto;
      } else if (valueImpuesto.tasaCuota === 4) {
        let cantidad = arrayValue[key].cantidad;
        if (cantidad) {
          totalImpuesto =
            (arrayValue[key].impuestos || 0) / arrayValue[key].cantidad;
        }
      } else if (valueImpuesto.tasaCuota === 5) {
        totalImpuesto = 0;
      }
      totalImpuestosPrecioSinImpuestos += totalImpuesto;
      return null;
    });
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
      Number(precioUnitario) + Number(totalImpuestosPrecioSinImpuestos)
    );
    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        insumo.retenciones.map((valueRetencion) => {
          if (
            (valueRetencion.aplicaCompra === 1 &&
              proveedor.persona === false) ||
            (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) ||
            valueRetencion.aplicaCompra === 3
          ) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(
                totalEntrada * (valueRetencion.monto / 100)
              );
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion = round6Decimals(
                (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
              );
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null;
        });
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  async onChangePrecioImpuestos(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    const insumo = arrayValue[key]?.insumoCompleto;
    if (!insumo) return;

    const precioUnitarioConImpuestos =
      arrayValue[key].precioUnitarioConImpuestos;

    let totalPorcentajeImpuestos = 1;
    let totalCantidadImpuestos = 0;
    insumo.impuestos.map((valueImpuesto) => {
      if (valueImpuesto.tasaCuota === 1) {
        totalPorcentajeImpuestos += valueImpuesto.monto / 100;
      } else if (valueImpuesto.tasaCuota === 2) {
        totalPorcentajeImpuestos +=
          totalPorcentajeImpuestos * (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 3) {
        totalCantidadImpuestos = valueImpuesto.monto;
      }
      return null;
    });

    const precioUnitario =
      precioUnitarioConImpuestos / totalPorcentajeImpuestos +
      totalCantidadImpuestos;
    arrayValue[key].precioUnitario = precioUnitario;
    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        insumo.retenciones.map((valueRetencion) => {
          if (
            (valueRetencion.aplicaCompra === 1 &&
              proveedor.persona === false) ||
            (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) ||
            valueRetencion.aplicaCompra === 3
          ) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(
                totalEntrada * (valueRetencion.monto / 100)
              );
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion = round6Decimals(
                (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
              );
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null;
        });
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }

  // async onChangeProveedor(value) {
  //   const proveedor = this.state.todasProveedores.find(
  //     (valueProv) => valueProv._id === value
  //   );
  //   if (!proveedor.tipoProveedorId) {
  //     const nombre = proveedor.persona
  //       ? proveedor.razonSocial
  //       : `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`;
  //     this.abrirElegirTipoDeProveedor(proveedor._id, nombre);
  //   }
  //   const fechaFactura = await this.formRef.current.getFieldValue(
  //     "fechaFactura"
  //   );
  //   this.formRef.current.setFieldsValue({
  //     fechaPago: moment(fechaFactura).add(proveedor.diasCredito, "days"),
  //     diasCredito: proveedor.diasCredito || 0,
  //   });
  //   let arrayValue = await this.formRef.current.getFieldValue("insumos");
  //   if (arrayValue?.length > 0) {
  //     arrayValue.map((valueInsumo, key) =>
  //       this.onChangePrecioCantidadDescuento(undefined, key)
  //     );
  //   }
  // }

  async onChangeProveedor(value, _, dejarInsumos) {
    const proveedor = this.state.todasProveedores.find(
      (valueProv) => valueProv._id === value
    );
    if (!proveedor.tipoProveedorId) {
      const nombre = proveedor.persona
        ? proveedor.razonSocial
        : `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`;
      this.abrirElegirTipoDeProveedor(proveedor._id, nombre);
    }
    const fechaFactura = await this.formRef.current.getFieldValue(
      "fechaFactura"
    );
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    this.formRef.current.setFieldsValue({
      insumos: dejarInsumos ? arrayValue : [],
      fechaPago: moment(fechaFactura).add(proveedor.diasCredito, "days"),
      diasCredito: proveedor.diasCredito || 0,
    });

    this.setState({ loading: false, proveedorId: value, });
  }

  onChangeMoneda(value) {
    if (value && value !== '60c7e4396465ad440c41c15a') {
      axios
        .post(
          "tipoDeCambio/obtenerTipoDeCambio",
          {
            monedaId: value,
            empresaId: this.props.empresaId,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            if (res.data.monedaString && res.data.dia) {
              message.success("Se ha obtenido el tipo de cambio" + (res.data.monedaString ? (" " + res.data.monedaString) : '') + (res.data.dia ? (' del día ' + res.data.dia) : ''));
            }
            this.formRef.current.setFieldsValue({
              tipoDeCambio: res.data.tipoDeCambio,
            });
          }
        });
    }
  }

/*
  async consultarInsumoProveedor(proveedorId) {
    await this.setState({ loading: true });
    await axios
      .post(
        "insumos/selectInsumosRelacionesProveedor",
        { empresaId: this.props.empresaId, proveedorId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({
            todasInsumos: [],
            objetoInsumos: (
              <Option disabled value={0} key={0}>
                No tiene insumos este proveedor
              </Option>
            ),
          });
        } else {
          this.setState({
            todasInsumos: res.data,
            objetoInsumos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
          });
        }
      });
  }*/

  atras() {
    this.props.history.push("/panel/facturascajachica");
  }
  async actualizarBoton() {
    await this.consultarTodo();
    let arrayValue = this.formRef.current.getFieldValue("insumos");
    if (arrayValue?.length > 0) {
      arrayValue.map((valueInsumo, key) =>
        this.onChangePrecioCantidadDescuento(undefined, key)
      );
    }
  }
  abrirElegirTipoDeProveedor(id, nombre) {
    this.setState({
      modalElegirTipoDeProveedor: true,
      modalElegirTipoDeProveedorId: id,
      modalElegirTipoDeProveedorNombre: nombre,
    });
  }

  cerrarElegirTipoDeProveedor(elegido) {
    if (!elegido) {
      this.formRef.current.setFieldsValue({ proveedorId: undefined });
    }
    this.consultarTodo();
    this.setState({
      modalElegirTipoDeProveedor: false,
      modalElegirTipoDeProveedorId: null,
      modalElegirTipoDeProveedorNombre: null,
    });
  }
async recargarInsumoEditado(proveedorId, insumoId, arrayKey) {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "insumos/selectInsumosRelacionesProveedor",
        {
          empresaId: this.props.empresaId,
          proveedorId: proveedorId,
          query: insumoId, 
          skip: 0
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2 && res.data.insumos && res.data.insumos.length > 0) {
        const insumoFresco = res.data.insumos[0];
        
        let arrayValue = this.formRef.current.getFieldValue("insumos");
        
        arrayValue[arrayKey].insumoCompleto = insumoFresco;
        
        arrayValue[arrayKey].precioUnitario = insumoFresco.costo || arrayValue[arrayKey].precioUnitario;
        
        this.formRef.current.setFieldsValue({ insumos: arrayValue });
        
        await this.onChangePrecioCantidadDescuento(undefined, arrayKey);
      }
    } catch (error) {
      console.error("Error recargando el insumo modificado:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  async leerXmlData(state) {
    await this.consultarTodo();
    this.setState({ loading: true });
    let insumosSinRegistrar = 0;
    let insumos = [];
    let proveedorId;
    let fechaFactura;
    let uuid;
    let codigoFactura;
    let tipoDeCambio;
    let monedaId;
    const hola = JSON.parse(state.fileData);
    const comprobante = hola?.attributes;
    const emisor = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Emisor"
    )?.attributes;
    const complemento = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Complemento"
    );
    const timbre = complemento.children.find(
      (valueXml) => valueXml.name === "tfd:TimbreFiscalDigital"
    )?.attributes;
    const receptor = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Receptor"
    )?.attributes;
    const conceptos = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Conceptos"
    )?.children;

    if (comprobante.TipoDeComprobante !== "I") {
      this.setState({
        archivosXml: [
          {
            name: state.fileName,
            status: "success",
          },
        ],
        archivo: state.fileData,
        loading: false,
      });
      return message.error("El xml no es una factura de ingreso");
    }

    if (receptor.Rfc?.toLowerCase() === this.state.empresaRfc?.toLowerCase()) {
      if (
        !this.state.todasProveedores?.find(
          (valueTodos) =>
            valueTodos.rfc?.toLowerCase() ===
            decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : "").toLowerCase()
        )
      ) {
        this.setState({
          loading: false,
        });
        notification.warning({
          message: "El proveedor no esta registrado",
        });
        return this.props.history.push("/panel/leerXml", {
          fileName: state.fileName,
          fileData: JSON.stringify(hola),
          origin: "/panel/agregarFacturaCajaChica",
        });
      } else {
        const proveedor = this.state.todasProveedores?.find(
          (valueTodos) =>
            valueTodos.rfc?.toLowerCase() ===
            decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : "").toLowerCase()
        );
        proveedorId = proveedor._id;
      }
    } else {
      this.setState({
        archivosXml: [
          {
            name: state.fileName,
            status: "success",
          },
        ],
        archivo: state.fileData,
        loading: false,
      });
      return message.error("El rfc del receptor no es igual al de la empresa");
    }

    avisarRegimenYObjetoImpXml({ receptor, conceptos, empresaId: this.props.empresaId, headersToken: this.props.headersToken });

    const conceptosData = conceptos.map((valueConcepto) => {
      const attr = valueConcepto.attributes;
      let totalImpuestos = 0;
      valueConcepto.children
        .find((valueTodos) => valueTodos.name === "cfdi:Impuestos")
        ?.children.find((valueTodos) => valueTodos.name === "cfdi:Traslados")
        ?.children.map((valueImpuesto) => {
          totalImpuestos += Number(valueImpuesto.attributes.Importe || 0);
          return null;
        });

      return {
        codigo: attr.NoIdentificacion,
        descripcion: attr.Descripcion,
        claveProdServ: attr.ClaveProdServ,
        claveUnidad: attr.ClaveUnidad,
        precioUnitario: Number(attr.ValorUnitario),
        cantidad: attr.Cantidad,
        unidad: attr.ClaveUnidad,
        descuento: attr.Descuento ? Math.round((attr.Descuento / attr.Importe) * 1000000) / 10000 : 0,
        impuestos: totalImpuestos,
      };
    });

    const res = await axios.post(
      "insumos/procesarXml",
      { empresaId: this.props.empresaId, proveedorId, conceptos: conceptosData },
      { headers: this.props.headersToken }
    );

    if (res.data.success === 2) {
      insumos = res.data.insumos;
      insumosSinRegistrar = res.data.insumosSinRegistrar;
    } else {
      message.error("Error al procesar los insumos del XML.");
      this.setState({ loading: false });
      return;
    }

    let subTotalEC = 0;
    let totalEC = 0;

    if (
      complemento &&
      complemento.children &&
      complemento.children.length > 0
    ) {
      const arrayComplemento = complemento.children.find(
        (valueXml) => valueXml.name === "ecc12:EstadoDeCuentaCombustible"
      );
      if (arrayComplemento) {
        subTotalEC = Number(arrayComplemento.attributes?.SubTotal || 0);
        totalEC = Number(arrayComplemento.attributes?.Total || 0);
        const { insumosSinRegistrarEC, insumosEC } =
          await this.leerEstadoDeCuentaCombustibles(
            arrayComplemento,
            proveedorId
          );
        insumosSinRegistrar += insumosSinRegistrarEC;
        insumos = [...insumos, ...insumosEC];
      }

      const arrayComplementoDespensa = complemento.children.find(
        (valueXml) => valueXml.name === "valesdedespensa:ValesDeDespensa"
      );
      if (arrayComplementoDespensa) {
        const { insumosSinRegistrarD, insumosD } =
          await this.leerValesDeDespensa(arrayComplementoDespensa, proveedorId);
        insumosSinRegistrar += insumosSinRegistrarD;
        insumos = [...insumos, ...insumosD];
      }
    }
    const pagosXML = {
      SubTotal:
        Number(comprobante.SubTotal) -
        Number(comprobante.Descuento || 0) +
        subTotalEC,
      Total: Number(comprobante.Total) + totalEC,
    };
    await this.setState({
      xmltotales: pagosXML,
      xmlDiagnostico: leerCfdiParaDiagnostico(hola),
    });

    fechaFactura = moment(comprobante.Fecha);
    codigoFactura =
      (comprobante.Serie ? comprobante.Serie : "") +
      " - " +
      (comprobante.Folio ? comprobante.Folio : "");
    uuid = timbre.UUID;
    tipoDeCambio = comprobante.TipoCambio || 1;

    if (insumosSinRegistrar > 0) {
      notification.warning({
        message: insumosSinRegistrar + " insumos no estan registrados",
      });
      return this.props.history.push("/panel/leerXml", {
        fileName: state.fileName,
        fileData: JSON.stringify(hola),
        origin: "/panel/agregarFacturaCajaChica",
      });
    }
    if (proveedorId) {
      this.onChangeProveedor(proveedorId, null, true);
    }
    if (uuid) {
      this.onChangeUUID(uuid);
    }

    const moneda = this.state.todasMonedas?.find(
      (valueTodos) =>
        valueTodos.abreviacion?.toLowerCase() ===
        comprobante.Moneda?.toLowerCase()
    );

    if (moneda) {
      monedaId = moneda._id;
    } else {
      message.info("No encontramos la moneda del comprobante");
      monedaId = "60c7e4396465ad440c41c15a";
    }

    const usoDeCfdiId = this.state.todasUsosDeCFDI?.find(
      (v) => v.c_UsoCFDI === receptor?.UsoCFDI
    )?._id || undefined;
    const _fplxd = comprobante?.FormaPago;
    const formaDePagoId = _fplxd
      ? this.state.todasFormasDePago?.find((v) => {
          const n = Number(_fplxd);
          return v.c_FormaPago === (isNaN(n) ? _fplxd : n);
        })?._id || undefined
      : undefined;
    const metodoPago = comprobante?.MetodoPago === "PUE" ? 1 : comprobante?.MetodoPago === "PPD" ? 2 : undefined;

    const proveedorEncontrado = this.state.todasProveedores?.find(p => p._id === proveedorId);
    const insumosCalculados = insumos.map((insumoRow) =>
      calcularTotalesInsumo(insumoRow, proveedorEncontrado)
    );
    await this.formRef.current.setFieldsValue({
      tipoDeCambio, monedaId,
      insumos: insumosCalculados,
      proveedorId, fechaFactura, codigoFactura, uuid,
      usoDeCfdiId, formaDePagoId, metodoPago,
    });
    await this.setState({ xmlFile: true });


    this.setState({
      archivosXml: [
        {
          name: state.fileName,
          status: "success",
        },
      ],
      archivo: state.fileData,
      loading: false,
    });
  }

  async leerXml(e) {
    this.setState({ loading: true });
    if (e.file.type === "text/xml") {
      var reader = new FileReader();
      reader.onload = async (event) => {
        let insumosSinRegistrar = 0;
        let insumos = [];
        let proveedorId;
        let fechaFactura;
        let uuid;
        let codigoFactura;
        let tipoDeCambio;
        let monedaId;
        const hola = new xmlToJson().parseFromString(event.target.result);
        const comprobante = hola?.attributes;
        const emisor = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Emisor"
        )?.attributes;
        const complemento = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Complemento"
        );
        const timbre = complemento.children.find(
          (valueXml) => valueXml.name === "tfd:TimbreFiscalDigital"
        )?.attributes;
        const receptor = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Receptor"
        )?.attributes;
        const conceptos = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Conceptos"
        )?.children;

        if (comprobante.TipoDeComprobante !== "I") {
          this.setState({
            archivosXml: [
              {
                ...e.file,
                name: e.file.name,
                status: "success",
              },
            ],
            archivo: e.file,
            loading: false,
          });
          return message.error("El xml no es una factura de ingreso");
        }

        if (
          receptor.Rfc?.toLowerCase() === this.state.empresaRfc?.toLowerCase()
        ) {
          if (
            !this.state.todasProveedores?.find(
              (valueTodos) =>
                valueTodos.rfc?.toLowerCase() ===
                decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : "").toLowerCase()
            )
          ) {
            this.setState({
              loading: false,
            });
            notification.warning({
              message: "El proveedor no esta registrado",
            });
            return this.props.history.push("/panel/leerXml", {
              fileName: e.file.name,
              fileData: JSON.stringify(hola),
              origin: "/panel/agregarFacturaCajaChica",
            });
          } else {
            const proveedor = this.state.todasProveedores?.find(
              (valueTodos) =>
                valueTodos.rfc?.toLowerCase() ===
                decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : "").toLowerCase()
            );
            proveedorId = proveedor._id;
          }
        } else {
          this.setState({
            archivosXml: [
              {
                ...e.file,
                name: e.file.name,
                status: "success",
              },
            ],
            archivo: e.file,
            loading: false,
          });
          return message.error(
            "El rfc del receptor no es igual al de la empresa"
          );
        }

        avisarRegimenYObjetoImpXml({ receptor, conceptos, empresaId: this.props.empresaId, headersToken: this.props.headersToken });

        const conceptosData = conceptos.map((valueConcepto) => {
          const attr = valueConcepto.attributes;
          let totalImpuestos = 0;
          valueConcepto.children
            .find((valueTodos) => valueTodos.name === "cfdi:Impuestos")
            ?.children.find((valueTodos) => valueTodos.name === "cfdi:Traslados")
            ?.children.map((valueImpuesto) => {
              totalImpuestos += Number(valueImpuesto.attributes.Importe || 0);
              return null;
            });

          return {
            codigo: attr.NoIdentificacion,
            descripcion: attr.Descripcion,
            claveProdServ: attr.ClaveProdServ,
            claveUnidad: attr.ClaveUnidad,
            precioUnitario: Number(attr.ValorUnitario),
            cantidad: attr.Cantidad,
            unidad: attr.ClaveUnidad,
            descuento: attr.Descuento ? Math.round((attr.Descuento / attr.Importe) * 1000000) / 10000 : 0,
            impuestos: totalImpuestos,
          };
        });

        const res = await axios.post(
          "insumos/procesarXml",
          { empresaId: this.props.empresaId, proveedorId, conceptos: conceptosData },
          { headers: this.props.headersToken }
        );

        if (res.data.success === 2) {
          insumos = res.data.insumos;
          insumosSinRegistrar = res.data.insumosSinRegistrar;
        } else {
          message.error("Error al procesar los insumos del XML.");
          this.setState({ loading: false });
          return;
        }

        let subTotalEC = 0;
        let totalEC = 0;

        if (
          complemento &&
          complemento.children &&
          complemento.children.length > 0
        ) {
          const arrayComplemento = complemento.children.find(
            (valueXml) => valueXml.name === "ecc12:EstadoDeCuentaCombustible"
          );
          if (arrayComplemento) {
            subTotalEC = Number(arrayComplemento.attributes?.SubTotal || 0);
            totalEC = Number(arrayComplemento.attributes?.Total || 0);
            const { insumosSinRegistrarEC, insumosEC } =
              await this.leerEstadoDeCuentaCombustibles(
                arrayComplemento,
                proveedorId
              );
            insumosSinRegistrar += insumosSinRegistrarEC;
            insumos = [...insumos, ...insumosEC];
          }

          const arrayComplementoDespensa = complemento.children.find(
            (valueXml) => valueXml.name === "valesdedespensa:ValesDeDespensa"
          );
          if (arrayComplementoDespensa) {
            const { insumosSinRegistrarD, insumosD } =
              await this.leerValesDeDespensa(arrayComplementoDespensa, proveedorId);
            insumosSinRegistrar += insumosSinRegistrarD;
            insumos = [...insumos, ...insumosD];
          }
        }
        const pagosXML = {
          SubTotal:
            Number(comprobante.SubTotal) -
            Number(comprobante.Descuento || 0) +
            subTotalEC,
          Total: Number(comprobante.Total) + totalEC,
        };
        await this.setState({
          xmltotales: pagosXML,
          xmlDiagnostico: leerCfdiParaDiagnostico(hola),
        });

        fechaFactura = moment(comprobante.Fecha);
        codigoFactura =
          (comprobante.Serie ? comprobante.Serie : "") +
          " - " +
          (comprobante.Folio ? comprobante.Folio : "");
        uuid = timbre.UUID;
        tipoDeCambio = comprobante.TipoCambio || 1;

        if (insumosSinRegistrar > 0) {
          notification.warning({
            message: insumosSinRegistrar + " insumos no estan registrados",
          });
          return this.props.history.push("/panel/leerXml", {
            fileName: e.file.name,
            fileData: JSON.stringify(hola),
            origin: "/panel/agregarFacturaCajaChica",
          });
        }
        if (uuid) {
          this.onChangeUUID(uuid);
        }
        if (proveedorId) {
          this.onChangeProveedor(proveedorId, null, true);
        }

        const moneda = this.state.todasMonedas?.find(
          (valueTodos) =>
            valueTodos.abreviacion?.toLowerCase() ===
            comprobante.Moneda?.toLowerCase()
        );

        if (moneda) {
          monedaId = moneda._id;
        } else {
          message.info("No encontramos la moneda del comprobante");
          monedaId = "60c7e4396465ad440c41c15a";
        }

        const usoDeCfdiId = this.state.todasUsosDeCFDI?.find(
          (v) => v.c_UsoCFDI === receptor?.UsoCFDI
        )?._id || undefined;
        const _fplx = comprobante?.FormaPago;
        const formaDePagoId = _fplx
          ? this.state.todasFormasDePago?.find((v) => {
              const n = Number(_fplx);
              return v.c_FormaPago === (isNaN(n) ? _fplx : n);
            })?._id || undefined
          : undefined;
        const metodoPago = comprobante?.MetodoPago === "PUE" ? 1 : comprobante?.MetodoPago === "PPD" ? 2 : undefined;

        const proveedorEncontrado = this.state.todasProveedores?.find(p => p._id === proveedorId);

        const insumosCalculados = insumos.map((insumoRow) =>
          calcularTotalesInsumo(insumoRow, proveedorEncontrado)
        );

        await this.formRef.current.setFieldsValue({
          monedaId,
          tipoDeCambio,
          insumos: insumosCalculados,
          proveedorId,
          fechaFactura,
          codigoFactura,
          uuid,
          usoDeCfdiId,
          formaDePagoId,
          metodoPago,
        });

        await this.setState({ xmlFile: true });

        
        this.setState({
          archivosXml: [
            {
              ...e.file,
              name: e.file.name,
              status: "success",
            },
          ],
          archivo: e.file,
          loading: false,
        });
      };

      reader.readAsText(e.file);
    } else {
      message.error("El archivo debe ser un archivo de xml");
      this.setState({ loading: false });
    }
  }

  async leerValesDeDespensa(complemento, proveedorId) {
    if (!complemento) return { insumosSinRegistrarD: 0, insumosD: [] };

    this.setState({ estadoDespensa: true });
    message.info("Leyendo vales de despensa");

    const arrayConceptos = complemento.children?.find(
      (v) => v.name === "valesdedespensa:Conceptos"
    );

    const totalDespensa = arrayConceptos?.children?.reduce(
      (acc, v) => acc + Number(v.attributes?.importe || 0),
      0
    ) || 0;

    const res = await axios.post(
      "insumos/procesarXml",
      {
        empresaId: this.props.empresaId,
        proveedorId,
        conceptos: [{
          codigo: "",
          descripcion: "Despensa",
          claveProdServ: "",
          claveUnidad: "E48",
          precioUnitario: round4Decimals(totalDespensa),
          cantidad: 1,
          unidad: "E48",
          descuento: 0,
          impuestos: 0,
        }],
      },
      { headers: this.props.headersToken }
    );

    if (res.data.success === 2) {
      return { insumosSinRegistrarD: res.data.insumosSinRegistrar, insumosD: res.data.insumos };
    } else {
      message.error("Error al procesar vales de despensa.");
      return { insumosSinRegistrarD: 0, insumosD: [] };
    }
  }

  async leerEstadoDeCuentaCombustibles(complemento, proveedorId) {
    if (!complemento) return;

    this.setState({ estadoCC: true });

    message.info("Leyendo estado de cuenta de combustibles");

    let insumosSinRegistrarEC = 0;
    let insumosEC = [];

    if (complemento.children && complemento.children.length > 0) {
      const arrayComplemento = complemento.children.find(
        (valueXml) => valueXml.name === "ecc12:Conceptos"
      );
      if (
        arrayComplemento &&
        arrayComplemento.children &&
        arrayComplemento.children.length > 0
      ) {
        const conceptosData = arrayComplemento.children.map((valueConcepto) => {
          const attr = valueConcepto.attributes;
          let totalImpuestos = 0;
          valueConcepto.children
            .find((valueTodos) => valueTodos.name === "ecc12:Traslados")
            ?.children.map((valueImpuesto) => {
              if (valueImpuesto.name === "ecc12:Traslado") {
                totalImpuestos += Number(valueImpuesto.attributes.Importe || 0);
              }
              return null;
            });

          return {
            codigo: attr.Identificador,
            descripcion: decodeHTMLEntities(attr.NombreCombustible),
            claveProdServ: attr.ClaveProdServ,
            claveUnidad: attr.Unidad,
            estadoCC: true,
            tipoCombustible: attr.TipoCombustible,
            precioUnitario: round4Decimals(Number(attr.Importe / attr.Cantidad)),
            cantidad: attr.Cantidad,
            unidad: attr.Unidad,
            descuento: 0,
            impuestos: totalImpuestos,
          };
        });

        const res = await axios.post(
          "insumos/procesarXml",
          { empresaId: this.props.empresaId, proveedorId, conceptos: conceptosData },
          { headers: this.props.headersToken }
        );

        if (res.data.success === 2) {
          insumosEC = res.data.insumos;
          insumosSinRegistrarEC = res.data.insumosSinRegistrar;
        } else {
          message.error("Error al procesar combustibles masivamente.");
        }
      }
    }

    return { insumosSinRegistrarEC, insumosEC };
  }

  onChangeUUID(value) {
    //Los uuid que no son del SAT (folios internos, capturas a medias) no se revisan
    if (!esUuidSat(value)) {
      if (this.state.uuidDuplicado) {
        this.setState({ uuidDuplicado: false, mensajeUuidDuplicado: undefined });
      }
      return;
    }
    axios
      .post(
        "facturas/checarUUID",
        { uuid: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.existeUUID === 1) {
          const mensaje =
            res.data.message ||
            "No se puede registrar: la factura ya existe en el sistema";
          this.setState({ uuidDuplicado: true, mensajeUuidDuplicado: mensaje });
          message.error(mensaje);
        } else {
          this.setState({ uuidDuplicado: false, mensajeUuidDuplicado: undefined });
        }
      });
  }

  abrirAgregarMarbetes(value, marbetes) {
    this.setState({
      modalAgregarMarbetes: true,
      modalAgregarMarbetesIndex: value,
      modalAgregarMarbetesMarbetes: marbetes,
    });
  }

  cerrarAgregarMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalAgregarMarbetesIndex].marbetes = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalAgregarMarbetes: false,
      modalAgregarMarbetesIndex: null,
      modalAgregarMarbetesMarbetes: null,
    });
  }

  onChangeProyecto(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");

    const proyecto = this.state.todasProyectos?.find(
      (valueP) => valueP._id === value
    );

    if (
      proyecto &&
      Array.isArray(proyecto.subProyectos) &&
      proyecto?.subProyectos?.length > 0
    ) {
      this.setState({
        proyectosConSubproyectos: true,
        objetoSubproyectos: proyecto.subProyectos.map((value) => (
          <Option key={value._id} value={value._id}>
            {value.codigo + " - " +value.nombre}
          </Option>
        )),
      });
    }

    if (Array.isArray(insumos) && insumos.length > 0) {
      const nuevosInsumos = insumos.map((insumo) => {
        if (!insumo.proyectoId) {
          insumo.proyectoId = value;
        }
        return insumo;
      });
      this.formRef.current.setFieldsValue({
        insumos: nuevosInsumos,
      });
    }
  }

  abrirAgregarLotes(value, lotes, vehiculo, insumoId) {
    this.setState({
      modalAgregarLotes: true,
      modalAgregarLotesIndex: value,
      modalAgregarLotesLotes: lotes,
      modalAgregarLotesVehiculo: vehiculo,
      modalAgregarLotesInsumoId : insumoId, 
    });
  }

  cerrarAgregarLotes(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalAgregarLotesIndex].lotes = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalAgregarLotes: false,
      modalAgregarLotesIndex: null,
      modalAgregarLotesLotes: null,
      modalAgregarLotesVehiculo: false,
      modalAgregarLotesInsumoId : null,
    });
  }

  abrirAgregarUnidadesActivo(index, unidades, cantidad, insumo) {
    this.setState({
      modalAgregarUnidadesActivo: true,
      modalAgregarUnidadesActivoIndex: index,
      modalAgregarUnidadesActivoUnidades: unidades,
      modalAgregarUnidadesActivoCantidad: cantidad,
      modalAgregarUnidadesActivoInsumo: insumo,
    });
  }

  cerrarAgregarUnidadesActivo(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalAgregarUnidadesActivoIndex].unidadesActivo = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalAgregarUnidadesActivo: false,
      modalAgregarUnidadesActivoIndex: null,
      modalAgregarUnidadesActivoUnidades: null,
      modalAgregarUnidadesActivoCantidad: 0,
      modalAgregarUnidadesActivoInsumo: null,
    });
  }

  // Al cerrar las etiquetas se sale de la pantalla, como haria el flujo normal.
  cerrarModalEtiquetasActivos() {
    const codigo = this.state.codigoFacturaCreada;
    this.setState({
      modalEtiquetasActivosVisible: false,
      entradaSalidaIdsEtiquetas: [],
      codigoFacturaCreada: null,
    });
    this.atras(codigo);
  }

  abrirSplitInsumo = (index) => {
    const insumos = this.formRef.current.getFieldValue("insumos") || [];
    const original = insumos[index];

    const cantidadOriginal = Number(original?.cantidad || 0);

    if (!cantidadOriginal || cantidadOriginal <= 0) {
      message.warning("Primero captura una cantidad para poder hacer el split.");
      return;
    }

    const insumo = insumos[index]?.insumoCompleto; 


    if (!insumo) {
      message.error("No se encontró el insumo a dividir.");
      return;
    }

    this.setState({
      modalSplitVisible: true,
      modalSplitIndex: index,
      modalSplitInsumo: insumo,
      modalSplitCantidad: cantidadOriginal,
    });
  };

  cerrarSplitInsumo = () => {
    this.setState({
      modalSplitVisible: false,
      modalSplitIndex: null,
      modalSplitCantidad: 0,
      modalSplitInsumo: null,
    });
  };

  confirmarSplitInsumo = (partidas) => {
    const { modalSplitCantidad, modalSplitIndex } = this.state;

    if (!Array.isArray(partidas) || partidas.length < 2) {
      message.error("Debes capturar al menos 2 partidas.");
      return;
    }

    const totalSplit = partidas.reduce(
      (acc, p) => acc + (Number(p.cantidad) || 0),
      0
    );

    if (totalSplit !== modalSplitCantidad) {
      message.error(
        `La suma de las cantidades (${totalSplit}) debe ser IGUAL a la cantidad original (${modalSplitCantidad}).`
      );
      return;
    }

    const insumos = this.formRef.current.getFieldValue("insumos") || [];
    const original = insumos[modalSplitIndex];

    if (!original) {
      message.error("No se encontró el insumo a dividir.");
      return;
    }

    // Crear nuevas líneas a partir del original
    const nuevasLineas = partidas.map((p) => ({
      ...original,
      proyectoId: p.proyectoId || original.proyectoId,
      subProyectoId: p.subProyectoId || original.subProyectoId,
      cantidad: Number(p.cantidad) || 0,
    }));

    // Reemplazar la línea original por las nuevas
    const nuevosInsumos = [...insumos];
    nuevosInsumos.splice(modalSplitIndex, 1, ...nuevasLineas);

    this.formRef.current.setFieldsValue({ insumos: nuevosInsumos });

    
    const proveedorId = this.formRef.current.getFieldValue("proveedorId");
    const proveedor = this.state.todasProveedores?.find(p => p._id === proveedorId);
    const insumosRecalculados = nuevosInsumos.map((insumoRow) =>
      calcularTotalesInsumo(insumoRow, proveedor)
    );
    this.formRef.current.setFieldsValue({ insumos: insumosRecalculados });

    this.cerrarSplitInsumo();
  };

  getInsumosColumns() {
    return [
      { title: "Clave",                   width: "5%" },
      { title: "Insumo",                  width: "13%" },
      { title: "Unidad",                  width: "5%" },
      { title: "Proyecto",                width: "9%" },
      { title: "Subp.",                   width: "8%" },
      { title: "P.U.",                    width: "7%" },
      { title: "P.U. c/Imp.",             width: "7%" },
      { title: "Cant.",                   width: "6%"  },
      { title: "Desc.",                   width: "6%"  },
      { title: "Subtotal / Imp. / Total", width: "10%" },
      { title: "Acción",                  width: "8%" },
    ];
  }

  renderProyectoCard() {
    return (
      <FormItem shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const proyectoId = getFieldValue("proyectoId");
          const proveedorId = getFieldValue("proveedorId");

          const proyecto = proyectoId
            ? this.state.todasProyectos?.find((v) => v._id === proyectoId)
            : null;

          const proveedor = proveedorId
            ? this.state.todasProveedores?.find((v) => v._id === proveedorId)
            : null;

          if (!proyecto && !proveedor) return null;

          const proveedorSections = proveedor
            ? [
                {
                  title: "Datos generales",
                  icon: <InfoCircleOutlined />,
                  iconColor: "#00BFD6",
                  lg: 14,
                  items: [
                    {
                      label: "Nombre",
                      value: proveedor.nombre
                        ? `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`
                        : proveedor.razonSocial || "-",
                      bold: true,
                    },
                    { label: "RFC",      value: proveedor.rfc      || "-" },
                    { label: "Correo",   value: proveedor.correo   || "-" },
                    { label: "Teléfono", value: proveedor.telefono || "-" },
                    { label: "Celular",  value: proveedor.celular  || "-" },
                  ],
                },
                {
                  title: "Contacto",
                  icon: <PhoneFilled />,
                  iconColor: "#DB2777",
                  lg: 10,
                  items: [
                    { label: "Nombre",          value: proveedor.nombreContacto   || "-" },
                    { label: "Teléfono",        value: proveedor.telefonoContacto || "-" },
                    { label: "Correo",          value: proveedor.correoContacto   || "-" },
                    { label: "Días de crédito", value: proveedor.diasCredito       ?? "-" },
                  ],
                },
              ]
            : [];

          if (!proyecto) {
            return (
              <Row>
                <InfoCard
                  title="PROVEEDOR"
                  accentColor="#00BFD6"
                  compact
                  sections={proveedorSections}
                />
              </Row>
            );
          }

          return (
            <Row>
              <InfoCard
                title="PROYECTO"
                accentColor="#00BFD6"
                icon={<InfoCircleOutlined />}
                compact
                sections={[
                  {
                    title: "Información General",
                    icon: <InfoCircleOutlined />,
                    iconColor: "#00BFD6",
                    lg: 8,
                    items: [
                      { label: "Nombre",      value: proyecto.nombre      || "-" },
                      { label: "Descripción", value: proyecto.descripcion || "-" },
                    ],
                  },
                  {
                    title: proyecto.calle ? "Dirección" : "Vehículo",
                    icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                    iconColor: "#C9DF00",
                    lg: 8,
                    items: proyecto.calle
                      ? [{ label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` }]
                      : [
                          { label: "Marca",  value: proyecto.marca  || "-" },
                          { label: "Modelo", value: proyecto.modelo || "-" },
                          { label: "Placas", value: proyecto.placas || "-" },
                        ],
                  },
                  {
                    title: "Detalles",
                    icon: <CarOutlined />,
                    iconColor: "#FF6A0D",
                    lg: 8,
                    items: [
                      { label: "Tipo", value: proyecto.calle ? "Dirección física" : "Vehículo" },
                      { label: "ID",   value: proyecto._id ? proyecto._id.slice(-6).toUpperCase() : "-" },
                    ],
                  },
                ]}
                splitWith={
                  proveedor
                    ? {
                        title: "PROVEEDOR",
                        accentColor:"#00BFD6",
                        icon:<UserOutlined />,
                        compact: true,
                        sections: proveedorSections,
                      }
                    : undefined
                }
              />
            </Row>
          );
        }}
      </FormItem>
    );
  }

  renderInsumoRow({ key, name, fieldKey, restField, arrayKey, remove }) {
    const insumos = this.formRef.current?.getFieldValue("insumos");
    const estadoCCPrimeroAqui = insumos?.[arrayKey]?.estadoCC && !insumos?.[arrayKey - 1]?.estadoCC;

    return (
      <React.Fragment key={key}>
        {estadoCCPrimeroAqui && (
          <tr>
            <td className="td-border-sin-right" colSpan="9" style={{ textAlign: "left", fontWeight: "bold", fontSize: 20, paddingLeft: 10 }}>
              <h1 style={{ paddingTop: 0, paddingBottom: 0 }}>Estado de Cuenta Combustibles</h1>
            </td>
          </tr>
        )}
        <tr>
          {/* Clave */}
          <td
            className="td-border"
            onDoubleClick={() => {
              const row = this.formRef.current.getFieldValue(['insumos', arrayKey]);
              const idParaDisponibilidad = row?.insumoCompleto?.insumoPrincipalId || row?.insumoCompleto?._id;
              this.abrirDisponibilidad(idParaDisponibilidad, row?.insumoCompleto?.nombre || row?.insumoCompleto?.descripcion || '', row?.proyectoId);
            }}
            style={{ cursor: 'pointer' }}
          >
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumo = getFieldValue(['insumos', arrayKey, 'insumoCompleto']);
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585', pointerEvents: 'none' }}>
                    {insumo?.clave || '-'}
                  </div>
                );
              }}
            </FormItem>
          </td>

          {/* Insumo */}
          <td className="td-border">
            <FormItem
                {...restField}
                name={[name, "insumoId"]}
                fieldKey={[arrayKey, "insumoId"]}
                required
                noStyle
            >
                <SelectInsumosItem
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    autoFocus
                    sinBorde
                    width="100%"
                    dropdownMatchSelectWidth={600}
                    placeholder="Insumo"
                    tiposInsumos="ordenDeCompra"
                    proveedorId={this.state.proveedorId}
                    ocultarCodigoYUnidad
                    onChange={(value, insumo) =>
                        this.onChangeInsumo(value, arrayKey, insumo)
                    }
                    insumoPreCargado={insumos ? insumos[arrayKey]?.insumoCompleto : null}
                />
            </FormItem>
        </td>

          <td className="td-border">
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const insumo = getFieldValue(['insumos', arrayKey, 'insumoCompleto']);
                  return (
                    <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                      {insumo?.unidad || '-'}
                    </div>
                  );
                }}
              </FormItem>
          </td>

          {/* Proyecto */}
          <td className="td-border">
            <FormItem {...restField} name={[name, "proyectoId"]} fieldKey={[arrayKey, "proyectoId"]} required noStyle>
              <SelectItem sinBorde autoFocus style={{ width: "100%" }} placeholder="Proyecto">
                {this.state.objetoProyectos}
              </SelectItem>
            </FormItem>
          </td>
          {/* Subproyecto */}
          <td className="td-border">
            <FormItem {...restField} noStyle shouldUpdate>
              {({ getFieldValue }) => {
                let arrayValue = getFieldValue("insumos");
                let subProyectos = null;
                if (arrayValue[arrayKey]?.proyectoId) {
                  const proyecto = this.state.todasProyectos?.find(v => v._id === arrayValue[arrayKey].proyectoId);
                  if (proyecto && Array.isArray(proyecto?.subProyectos)) {
                    subProyectos = proyecto.subProyectos.map(value => (
                      <Option value={value._id} key={value._id}>{value.nombre}</Option>
                    ));
                  }
                }
                if (subProyectos && subProyectos.length > 0) {
                  return (
                    <FormItem {...restField} name={[name, "subProyectoId"]} fieldKey={[arrayKey, "subProyectoId"]} noStyle>
                      <SelectItem sinBorde style={{ width: "100%" }} placeholder="Subproyecto">{subProyectos}</SelectItem>
                    </FormItem>
                  );
                }
                return null;
              }}
            </FormItem>
          </td>
          {/* Precio Unitario */}
          <td className="td-border">
            <FormItem {...restField} name={[name, "precioUnitario"]} fieldKey={[arrayKey, "precioUnitario"]} noStyle required numberCero>
              <InputNumberItem sinBorde placeholder="Precio Unitario" onChange={v => this.onChangePrecioCantidadDescuento(v, arrayKey)} dinero />
            </FormItem>
          </td>
          {/* Precio Unitario con Impuestos (combustible) */}
          <td className="td-border">
            <FormItem {...restField} noStyle shouldUpdate>
              {({ getFieldValue }) => {
                let arrayValue = getFieldValue("insumos");
                let disabled = true;
                if (arrayValue[arrayKey]?.insumoId) {
                  disabled = !!arrayValue[arrayKey].insumoCompleto?.impuestos?.[0]?.combustible;
                }
                return (
                  <FormItem name={[name, "precioUnitarioConImpuestos"]} noStyle required numberCero shouldUpdate>
                    <InputNumberItem
                      sinBorde disabled={disabled}
                      placeholder="Precio Unitario con Impuestos"
                      onChange={v => this.onChangePrecioImpuestos(v, arrayKey)}
                      dinero={!disabled} dineroDisabled={disabled}
                    />
                  </FormItem>
                );
              }}
            </FormItem>
          </td>
          {/* Cantidad */}
          <td className="td-border">
            <FormItem {...restField} name={[name, "cantidad"]} fieldKey={[arrayKey, "cantidad"]} required number noStyle>
              <InputNumberItem sinBorde placeholder="Cantidad" onChange={v => this.onChangePrecioCantidadDescuento(v, arrayKey)} />
            </FormItem>
          </td>
          {/* Descuento */}
          <td className="td-border">
            <FormItem {...restField} name={[name, "descuento"]} fieldKey={[arrayKey, "descuento"]} required numberCero noStyle shouldUpdate initialValue={0}>
              <InputNumberItem sinBorde placeholder="Descuento" porcentaje max={100} onChange={v => this.onChangePrecioCantidadDescuento(v, arrayKey)} />
            </FormItem>
          </td>
          {/* Subtotal / Impuestos / Total combinados */}
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const arr       = getFieldValue("insumos");
                const subtotal  = arr?.[arrayKey]?.subtotal  || 0;
                const impuestos = arr?.[arrayKey]?.impuestos || 0;
                const total     = arr?.[arrayKey]?.total     || 0;
                const combustible = !!arr?.[arrayKey]?.insumoCompleto?.impuestos?.[0]?.combustible;
                return (
                  <div className="celda-totales" style={{ fontSize: "12px" }}>
                    <div>{dineroDisabledMask(subtotal)}</div>
                    {combustible ? (
                      <FormItem name={[name, "impuestos"]} required numberCero noStyle>
                        <InputNumberItem
                          sinBorde
                          dinero
                          onChange={v => this.onChangePrecioCantidadDescuento(v, arrayKey)}
                        />
                      </FormItem>
                    ) : (
                      <div>{dineroDisabledMask(impuestos)}</div>
                    )}
                    <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                  </div>
                );
              }}
            </FormItem>
            <FormItem {...restField} name={[name, "subtotal"]} fieldKey={[arrayKey, "subtotal"]} required numberCero noStyle shouldUpdate hidden><InputNumberItem /></FormItem>
            <FormItem {...restField} name={[name, "impuestos"]} fieldKey={[arrayKey, "impuestos"]} required numberCero noStyle shouldUpdate hidden><InputNumberItem /></FormItem>
            <FormItem {...restField} name={[name, "total"]}    fieldKey={[arrayKey, "total"]}    required numberCero noStyle shouldUpdate hidden><InputNumberItem /></FormItem>
          </td>
          {/* Acción */}
          <td className="td-border-sin-right">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                let arrayValue = getFieldValue("insumos");
                let mostrarMarbetes = false;
                let mostrarLotes = false;
                let mostrarVehiculo = false;
                let insumoFila = null;
                if (arrayValue[arrayKey]?.insumoId) {
                  const insumo = arrayValue[arrayKey].insumoCompleto;
                  insumoFila = insumo;
                  mostrarMarbetes = insumo?.marbetes;
                  mostrarLotes = insumo?.lotesCaducidades;
                  mostrarVehiculo = insumo?.vehiculo;
                }
                // Activo fijo: solo tiene sentido capturar unidades si la
                // factura se va a recibir en este momento.
                const mostrarUnidadesActivo =
                  insumoFila?.esActivoFijo && getFieldValue("recibirInsumos");
                return (
                  <Space
                    style={{ width: "100%", display: "flex", justifyContent: "flex-start", alignItems: "center" }}
                    size={4}
                    className="acciones-container"
                  >
                    <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                      <ButtonItem rojo2 icon={<DeleteOutlined />} onClick={() => remove(name)} size="small" />
                    </Tooltip>
                    <Tooltip title="Dividir" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                      <ButtonItem icon={<SplitCellsOutlined />} onClick={() => this.abrirSplitInsumo(arrayKey)} size="small" />
                    </Tooltip>
                    {mostrarUnidadesActivo && (
                      <Tooltip title="Unidades de activo fijo" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                        <ButtonItem
                          type="primary"
                          size="small"
                          cyan2
                          icon={<DatabaseOutlined />}
                          disabled={(Number(arrayValue[arrayKey]?.cantidad) || 0) <= 0}
                          onClick={() => {
                            this.abrirAgregarUnidadesActivo(
                              arrayKey,
                              arrayValue[arrayKey]?.unidadesActivo,
                              Number(arrayValue[arrayKey]?.cantidad) || 0,
                              insumoFila
                            );
                          }}
                        >
                          Unidades
                        </ButtonItem>
                      </Tooltip>
                    )}
                    {mostrarLotes && (
                      <Tooltip title={this.props.taxidermia ? "Animales" : "Lotes"} placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                        <ButtonItem
                          type="primary"
                          size="small"
                          cyan2
                          icon={<DatabaseOutlined />}
                          onClick={() => {
                            const insumoId = arrayValue[arrayKey]?.insumoCompleto?.insumoPrincipalId;
                            this.abrirAgregarLotes(arrayKey, arrayValue[arrayKey]?.lotes, mostrarVehiculo, insumoId);
                          }}
                        >
                          {this.props.taxidermia ? "Animales" : "Lotes"}
                        </ButtonItem>
                      </Tooltip>
                    )}
                    {mostrarMarbetes && (
                      <Tooltip title="Marbetes" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                        <ButtonItem
                          type="primary"
                          size="small"
                          amarillo2
                          icon={<TagsOutlined />}
                          onClick={() => this.abrirAgregarMarbetes(arrayKey, arrayValue[arrayKey].marbetes)}
                        >
                          Marbetes
                        </ButtonItem>
                      </Tooltip>
                    )}
                  </Space>
                );
              }}
            </FormItem>
          </td>
        </tr>
        {/* Fila de detalles del insumo */}
        {this.state.mostrarDetalles && (
          <FormItem noStyle shouldUpdate={(prevValues, currentValues) => {
            const prev = prevValues.insumos?.[arrayKey];
            const curr = currentValues.insumos?.[arrayKey];
            return prev?.cantidad !== curr?.cantidad || prev?.insumoId !== curr?.insumoId || prev?.precioUnitario !== curr?.precioUnitario;
          }}>
            {({ getFieldValue }) => {
              const ins = getFieldValue("insumos");
              const insumoData = ins?.[arrayKey];
              const cantidad = insumoData?.cantidad;
              const costo = insumoData?.precioUnitario;
              const insumoId = insumoData?.insumoId;
              const insumo = insumoData?.insumoCompleto;
              if (!insumo) return null;
              return (
                <InsumoDetalleRow
                  insumo={insumo} cantidad={cantidad} costo={costo}
                  colSpans={{ details: 5, projection: 2, filler: 4 }}
                  onCloseModal={async () => {
                    const currentProveedorId = this.formRef.current.getFieldValue("proveedorId");
                    await this.recargarInsumoEditado(currentProveedorId, insumoId, arrayKey);
                  }}
                />
              );
            }}
          </FormItem>
        )}
      </React.Fragment>
    );
  }

  getObservacionesConfig() {
    return {
      totales: (
        <FormItem shouldUpdate noStyle>
          {({ getFieldValue }) => {
            let arrayInsumos = getFieldValue("insumos") || [];
            let ajusteSubtotal = getFieldValue("ajusteSubtotal") || 0;
            let arrayRetenciones = [];
            let cuentasProveedor = 0;
            let subtotal = 0;
            let subtotalVI = 0;
            let arrayImpuestos = [];
            let total = 0;
            arrayInsumos.forEach((value) => {
              if (value && value.subtotal && value.total && value.arrayImpuestos) {
                subtotal += value.subtotal;
                subtotalVI += value.subtotal;
                total += value.subtotal;
                value.arrayImpuestos.forEach((valueImpuestos) => {
                  let index = arrayImpuestos.findIndex(v => v.descripcionFactura === valueImpuestos.descripcionFactura);
                  if (index !== -1) { arrayImpuestos[index].totalImpuestos += valueImpuestos.totalImpuestos; }
                  else { arrayImpuestos.push({ totalImpuestos: valueImpuestos.totalImpuestos, descripcionFactura: valueImpuestos.descripcionFactura }); }
                });
                if (value.arrayRetenciones) {
                  value.arrayRetenciones.forEach((valueRetenciones) => {
                    let index = arrayRetenciones.findIndex(v => v.descripcionFactura === valueRetenciones.descripcionFactura);
                    cuentasProveedor += round2Decimals(valueRetenciones.totalRetenciones);
                    if (index !== -1) { arrayRetenciones[index].totalRetenciones += valueRetenciones.totalRetenciones; }
                    else { arrayRetenciones.push({ totalRetenciones: valueRetenciones.totalRetenciones, descripcionFactura: valueRetenciones.descripcionFactura }); }
                  });
                }
              }
            });
            let cuentasProveedorVI = cuentasProveedor;
            subtotal += ajusteSubtotal;
            total += ajusteSubtotal;
            arrayImpuestos = arrayImpuestos.map((valueImpuesto) => {
              let ajusteImpuesto = getFieldValue("ajuste" + valueImpuesto.descripcionFactura) || 0;
              total += round2Decimals(valueImpuesto.totalImpuestos + ajusteImpuesto);
              return { ...valueImpuesto, totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos + ajusteImpuesto), totalImpuestosVI: valueImpuesto.totalImpuestos };
            });
            arrayRetenciones = arrayRetenciones.map((valueRetencion) => {
              let ajusteRetencion = getFieldValue("ajuste" + valueRetencion.descripcionFactura) || 0;
              cuentasProveedor += ajusteRetencion;
              return { ...valueRetencion, totalRetenciones: valueRetencion.totalRetenciones + ajusteRetencion, totalRetencionesVI: valueRetencion.totalRetenciones };
            });
            const diferenciaXml = round2Decimals(
              round2Decimals(Number(this.state.xmltotales?.Total || 0)) -
                round2Decimals(total - cuentasProveedor)
            );
            return (
              <div style={{ marginTop: 8 }}>
                {this.state.xmlFile && (
                  <div style={{ textAlign: "right", marginBottom: 8 }}>
                    <Space wrap>
                      <ButtonItem
                        {...(diferenciaXml === 0 ? { blanco: true } : { rojo: true })}
                        icon={<QuestionCircleOutlined />}
                        onClick={() =>
                          this.abrirDiagnosticoCuadre({
                            subtotal,
                            ajusteSubtotal,
                            total,
                            cuentasProveedor,
                            arrayImpuestos,
                            arrayRetenciones,
                            subtotalVI,
                            cuentasProveedorVI,
                          })
                        }
                      >
                        {diferenciaXml === 0
                          ? "Comparar con XML"
                          : "¿Por qué no cuadra? " + dineroDisabledMask(diferenciaXml)}
                      </ButtonItem>
                      <ButtonItem
                        ambar
                        icon={<ToolOutlined />}
                        onClick={() =>
                          this.ajustarTotalesAutomaticamente({
                            subtotalVI,
                            cuentasProveedorVI,
                            arrayImpuestos,
                            arrayRetenciones,
                          })
                        }
                      >
                        Ajustar automáticamente
                      </ButtonItem>
                    </Space>
                  </div>
                )}
                <table className="table totales-table" style={{ borderCollapse: "collapse", width: "100%", margin: 0 }}>
                  <tbody>
                     <tr>
                      <th className="td-totales-center" style={{ width: "25%"}}></th>
                      <td className="td-totales-center" style={{ width: "15%"}}>
                          <Tag style={{ backgroundColor: "#f5f5f5",borderColor: "#d9d9d9", color: "#595959",fontWeight: 600, padding: "2px 50px",borderRadius: "6px"
                          }}
                        >
                          Ajuste
                        </Tag>
                      </td>
                      <td className="td-totales-center" style={{ width: "25%" }}></td>
                      {this.state.xmlFile && (
                          <td className="td-totales-center" style={{ width: "25%"}}>
                          <Tag style={{ backgroundColor: "#f5f5f5",borderColor: "#d9d9d9", color: "#595959",fontWeight: 600, padding: "2px 60px",borderRadius: "6px"
                          }}
                        >
                          XML
                        </Tag>
                      </td>
                      )}
                    </tr>
                    <tr>
                      <th className="th-totales" style={{ width: "50%" }}>Subtotal</th>
                      <td className="td-totales-right" style={{ width: "20%" }}>
                        <FormItem name="ajusteSubtotal" numberNegativo noStyle max={this.state.ajusteMax} min={Math.max(-this.state.ajusteMax, -subtotalVI)} type="number" required initialValue={0}>
                          <InputNumberItem step={0.01} sinBorde dinero precision={2} placeholder={"Max: ±" + this.state.ajusteMax} />
                        </FormItem>
                      </td>
                      <td className="td-totales-right" style={{ width: "30%" }}>{dineroDisabledMask(subtotal)}</td>
                      {this.state.xmlFile && <td className="td-totales-right" style={{ width: "40%" }}>{dineroDisabledMask(this.state.xmltotales?.SubTotal)}</td>}

                    </tr>
                  </tbody>
                  {arrayImpuestos.map((valueArray) => (
                    <tbody key={valueArray.descripcionFactura}>
                      <tr>
                        <th className="th-totales">{valueArray.descripcionFactura}</th>
                        <td className="td-totales-right" style={{ width: "20%" }}>
                          <FormItem name={"ajuste" + valueArray.descripcionFactura} numberNegativo noStyle max={this.state.ajusteMax} min={Math.max(-this.state.ajusteMax, -valueArray.totalImpuestosVI)} type="number" required initialValue={0} precision={2}>
                            <InputNumberItem step={0.01} sinBorde dinero placeholder={"Max: ±" + this.state.ajusteMax} />
                          </FormItem>
                        </td>
                        <td className="td-totales-right">{dineroDisabledMask(valueArray.totalImpuestos)}</td>
                        {this.state.xmlFile && <td className="td-totales-right"></td>}
                      </tr>
                    </tbody>
                  ))}
                  <tbody>
                    <tr>
                      <th className="th-totales">Total</th>
                      <td className="td-totales-right" style={{ width: "20%" }}></td>
                      <td className="td-totales-right">{dineroDisabledMask(total)}</td>
                      {this.state.xmlFile && <td className="td-totales-right"></td>}
                    </tr>
                  </tbody>
                  {arrayRetenciones.map((value) => (
                    <tbody key={value.descripcionFactura}>
                      <tr>
                        <th className="th-totales">{value.descripcionFactura}</th>
                        <td className="td-totales-right" style={{ width: "20%" }}>
                          <FormItem name={"ajuste" + value.descripcionFactura} numberNegativo noStyle max={this.state.ajusteMax} min={Math.max(-this.state.ajusteMax, -value.totalRetencionesVI)} type="number" required initialValue={0} precision={2}>
                            <InputNumberItem step={0.01} sinBorde dinero placeholder={"Max: ±" + this.state.ajusteMax} />
                          </FormItem>
                        </td>
                        <td className="td-totales-right">{dineroDisabledMask(value.totalRetenciones)}</td>
                        {this.state.xmlFile && <td className="td-totales-right"></td>}
                      </tr>
                    </tbody>
                  ))}
                  <tbody>
                    <tr>
                      <th className="th-totales">Total a pagar</th>
                      <td className="td-totales-right" style={{ width: "20%" }}></td>
                      <td className="td-totales-right">{dineroDisabledMask(total - cuentasProveedor)}</td>
                      {this.state.xmlFile && <td className="td-totales-right">{dineroDisabledMask(this.state?.xmltotales?.Total)}</td>}
                    </tr>
                  </tbody>
                </table>
              </div>
            );
          }}
        </FormItem>
      ),
    };
  }

  /*
    Arma el diagnostico con lo que el bloque de totales ya tiene acumulado. Se calcula al abrir el
    modal y no en cada render, porque el FormItem con shouldUpdate se re-renderiza en cada tecla.
  */
  abrirDiagnosticoCuadre(acumulados) {
    const capturado = construirCapturadoDesdeTotales({
      ...acumulados,
      arrayInsumos: this.formRef.current.getFieldValue("insumos"),
      resolverInsumo: (valueRenglon) => valueRenglon.insumoCompleto,
      proveedor: this.state.todasProveedores?.find(
        (valueTodos) => valueTodos._id === this.formRef.current.getFieldValue("proveedorId")
      ),
      ajusteMax: this.state.ajusteMax,
    });
    this.setState({
      modalDiagnosticoVisible: true,
      diagnostico: diagnosticarCuadreFactura({ xml: this.state.xmlDiagnostico, capturado }),
      ajusteContexto: {
        subtotalVI: acumulados.subtotalVI,
        cuentasProveedorVI: acumulados.cuentasProveedorVI,
        arrayImpuestos: acumulados.arrayImpuestos,
        arrayRetenciones: acumulados.arrayRetenciones,
      },
    });
  }

  ajustarTotalesAutomaticamente({ subtotalVI, cuentasProveedorVI, arrayImpuestos, arrayRetenciones }) {
    const resultado = calcularAjusteAutomaticoFactura({
      subtotalVI,
      cuentasProveedorVI,
      arrayImpuestos,
      arrayRetenciones,
      xmltotales: this.state.xmltotales,
      ajusteMax: this.state.ajusteMax,
    });
    const aplicarAjuste = () => {
      this.formRef.current.setFieldsValue(resultado.ajustes);
      if (resultado.restante !== 0) {
        message.warning(
          "No fue posible cubrir toda la diferencia automáticamente, queda una diferencia de $" +
            Math.abs(resultado.restante).toFixed(2) +
            " por el límite de ajuste configurado."
        );
      }
    };
    if (Math.abs(resultado.diferenciaOriginal) > 0.5) {
      Modal.confirm({
        title: "Diferencia considerable",
        content:
          "La diferencia entre el total del XML y el total capturado es de $" +
          Math.abs(resultado.diferenciaOriginal).toFixed(2) +
          ", lo cual es una diferencia considerable. ¿Desea realizar el ajuste automático de todas formas?",
        okText: "Sí, ajustar",
        cancelText: "Cancelar",
        onOk: aplicarAjuste,
      });
    } else {
      aplicarAjuste();
    }
  }

  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Factura Caja Chica"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space>
              {this.props.permisoAccesoLeerXml && (
                <Upload
                  showUploadList={{
                    showRemoveIcon: false,
                    showPreviewIcon: false,
                  }}
                  fileList={this.state.archivosXml}
                  customRequest={this.leerXml.bind(this)}
                  accept=".xml"
                >
                  <ButtonItem type="primary" icon={<UploadOutlined />}>
                    Leer Xml
                  </ButtonItem>
                </Upload>
              )}
              <ButtonItem blanco onClick={this.actualizarBoton.bind(this)}>
                Actualizar Informacion
              </ButtonItem>
            </Space>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarFacturaCajaChica"
              layout
              onFinish={(values) =>
                this.setState({
                  modalConfirmacion: true,
                  valuesForm: values,
                })
              }
              onFinishFailed={this.onFinishFailed}
            >
              <div style={{ padding: '0 16px', marginBottom: 16 }}>
                {this.renderProyectoCard()}
              </div>
              <GeneralFormLayout
                cards={[
                  {
                    title: "Datos Generales",
                    lg: 24,
                    content: (
                      <Row gutter={16}>
                      <Col span={12}>
                        <FormItem
                          label="Proyecto"
                          name="proyectoId"
                          margin
                          required
                          labelCol={{ span: 5 }}
                          wrapperCol={{ span: 16 }}
                        >
                          <SelectItem
                            onChange={(value) => this.onChangeProyecto(value)}
                            placeholder="Proyecto"
                          >
                            {this.state.objetoProyectos}
                          </SelectItem>
                        </FormItem>

                        {this.state.proyectosConSubproyectos && (
                          <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              let proyectoId = getFieldValue("proyectoId");
                              if (!proyectoId) return null;

                              return (
                                <FormItem
                                  label="Subproyecto"
                                  name="subProyectoId"
                                  margin
                                  labelCol={{ span: 5 }}
                                  wrapperCol={{ span: 16 }}
                                >
                                  <SelectItem placeholder="Subproyecto" allowClear>
                                    {this.state.objetoSubproyectos}
                                  </SelectItem>
                                </FormItem>
                              );
                            }}
                          </FormItem>
                        )}
                      </Col>

                      <Col span={12}>
                        <FormItem
                          label="Proveedor"
                          name="proveedorId"
                          margin
                          required
                          labelCol={{ span: 5 }}
                          wrapperCol={{ span: 16 }}
                        >
                          <SelectItem
                            placeholder="Proveedor"
                            onChange={this.onChangeProveedor.bind(this)}
                          >
                            {this.state.objetoProveedores}
                          </SelectItem>
                        </FormItem>
                      </Col>
                      {this.state.prorrateoDesCostos && (
                        <Col span={12}>
                          <FormItem
                            name="prorrateo"
                            label="Prorrateo de costos"
                            valuePropName="checked"
                            initialValue={false}
                            margin
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Switch size="small" />
                          </FormItem>
                        </Col>
                      )}
                    </Row>
                    ),
                  },
                       {
                    title: "Datos Factura",
                    lg: 18,
                    content: (
                      <Row gutter={[16, 0]}>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="codigoFactura" label="Codigo Factura" margin pattern>
                            <InputItem placeholder="Codigo Factura" />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem label="Caja Chica" name="cajaId" margin required>
                            <SelectItem placeholder="Caja Chica">
                              {this.state.objetoCajaChica}
                            </SelectItem>
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="usoDeCfdiId" label="Uso de CFDI" margin>
                            <SelectItem placeholder="Uso de CFDI" allowClear>
                              {this.state.objetoUsosDeCFDI}
                            </SelectItem>
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem label="Fecha de Factura" name="fechaFactura" required margin>
                            <DatePickerItem
                              placeholder="Fecha de Factura"
                              allowClear={false}
                              onChange={(value) => {
                                const fechaFactura = moment(value);
                                const diasCredito = this.formRef.current.getFieldValue("diasCredito");
                                this.formRef.current.setFieldsValue({
                                  fechaPago: fechaFactura.add(diasCredito, "days"),
                                });
                              }}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem
                            name="formaDePagoId"
                            label="Forma de Pago"
                            initialValue="6125149afe07662acc100d58"
                            margin
                            required
                          >
                            <SelectItem placeholder="Forma de Pago">
                              {this.state.objetoFormasDePago}
                            </SelectItem>
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="uuid" label="UUID" margin pattern required>
                            <InputItem
                              onChange={(e) => this.onChangeUUID(e.target.value)}
                              placeholder="UUID"
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="descripcion" label="Descripcion" margin pattern>
                            <InputItem placeholder="Descripcion" />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="metodoPago" label="Método de Pago" margin>
                            <SelectItem placeholder="Método de Pago" allowClear>
                              <Option value={1}>PUE - Pago en Una sola Exhibición</Option>
                              <Option value={2}>PPD - Pago en Parcialidades o Diferido</Option>
                            </SelectItem>
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 6,
                    content: (
                      <>
                    <FormItem
                      noStyle
                      shouldUpdate={(prev, curr) =>
                        prev.insumos?.length !== curr.insumos?.length
                      }
                    >
                      {({ getFieldValue }) => {
                        const insumos = getFieldValue("insumos");
                        const disabled =
                          insumos && insumos.length > 0 ? true : false;
                        return (
                          <FormItem
                            required
                            margin
                            name="monedaId"
                            label="Moneda"
                            labelCol={{ span: 8 }}
                            wrapperCol={{
                              span: 16,
                            }}
                            initialValue="60c7e4396465ad440c41c15a"
                          >
                            <SelectItem
                              disabled={disabled}
                              onChange={(value) => {
                                if (value === "60c7e4396465ad440c41c15a") {
                                  this.formRef.current.setFieldsValue({
                                    tipoDeCambio: 1,
                                  });
                                } else {
                                  this.onChangeMoneda(value);
                                }
                              }}
                              placeholder="Moneda"
                            >
                              {this.state.objetoMonedas}
                            </SelectItem>
                          </FormItem>
                        );
                      }}
                    </FormItem>
                    <FormItem
                      noStyle
                      shouldUpdate={(prev, curr) =>
                        prev.monedaId !== curr.monedaId ||
                        prev.insumos?.length !== curr.insumos?.length
                      }
                    >
                      {({ getFieldValue }) => {
                        const monedaId = getFieldValue("monedaId");
                        const insumos = getFieldValue("insumos");
                        const disabled =
                          insumos && insumos.length > 0 ? true : false;

                        return monedaId !== "60c7e4396465ad440c41c15a" ? (
                          <FormItem
                            required
                            number
                            margin
                            label="T. Cambio"
                            name="tipoDeCambio"
                            type="number"
                            initialValue={1}
                            labelCol={{ span: 8 }}
                            wrapperCol={{
                              span: 16,
                            }}
                          >
                            <InputNumberItem
                              disabled={disabled}
                              dinero
                              placeholder="T. Cambio"
                            />
                          </FormItem>
                        ) : (
                          <FormItem name="tipoDeCambio" initialValue={1} hidden>
                            <InputNumberItem />
                          </FormItem>
                        );
                      }}
                    </FormItem>
                      </>
                    ),
                  },
             
                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow.bind(this),
                      renderHeader: ({ fields, add }) => (
                        <Row justify="space-between" align="middle" style={{ marginBottom: 4 ,  marginRight: "15px" }}>
                          <Col>
                            <FormItem
                              name="recibirInsumos"
                              label="Recibir Insumos"
                              margin
                              valuePropName="checked"
                              initialValue={true}
                              style={{ marginBottom: 0 }}
                              labelCol={{ span: 21 }}
                              wrapperCol={{ span: 3 }}
                            >
                                <Checkbox disabled={this.state.estadoCC}></Checkbox>
                            </FormItem>
                          </Col>
                          <Col>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Mostrar detalles:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.mostrarDetalles}
                                onChange={(checked) => this.setState({ mostrarDetalles: checked })}
                              />
                            </Space>
                          </Col>
                        </Row>
                      ),
                      renderFooter: ({ add,fields }) => (
                        <FormItem noStyle>
                          <ButtonItem
                            style={{
                                marginTop: 10,
                                marginBottom: 10,
                                justifySelf: fields.length > 0 ? "left" : null,
                                width: fields.length > 0 ? "auto" : null,
                            }}
                            type="primary"
                            onClick={() => add()}
                            block
                            hotkey="alt+a"
                            cyan
                            icon={<PlusOutlined />}
                          >
                            Agregar Insumo
                          </ButtonItem>
                        </FormItem>
                      ),
                    },
                  ],
                }}
                observacionesConfig={this.getObservacionesConfig()}
                actionButtons={
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    cyanB
                    disabled={this.state.uuidDuplicado}
                    hotkey="shift+r"
                  >
                    Recibir
                  </ButtonItem>
                }
              />
            </Form>
          </Spin>
        </div>
        <ModalItem
          title="Confirmacion"
          visible={this.state.modalConfirmacion}
          onCancel={() => this.setState({ modalConfirmacion: false })}
          onOk={() => {
            this.setState({ modalConfirmacion: false });
            this.onFinish(this.state.valuesForm);
          }}
          spinning={false}
          footer
        >
          <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
        </ModalItem>
        <ElegirTipoDeProveedor
          visible={this.state.modalElegirTipoDeProveedor}
          id={this.state.modalElegirTipoDeProveedorId}
          nombre={this.state.modalElegirTipoDeProveedorNombre}
          cerrarElegirTipoDeProveedor={this.cerrarElegirTipoDeProveedor.bind(
            this
          )}
        />
        <AgregarMarbetes
          visible={this.state.modalAgregarMarbetes}
          cerrarAgregarMarbetes={this.cerrarAgregarMarbetes.bind(this)}
          marbetes={this.state.modalAgregarMarbetesMarbetes}
        />
        <AgregarLotes
          visible={this.state.modalAgregarLotes}
          cerrarAgregarLotes={this.cerrarAgregarLotes.bind(this)}
          lotes={this.state.modalAgregarLotesLotes}
          vehiculo={this.state.modalAgregarLotesVehiculo}
          insumoId = { this.state.modalAgregarLotesInsumoId}
        />
        <AgregarUnidadesActivo
          visible={this.state.modalAgregarUnidadesActivo}
          cerrarAgregarUnidades={this.cerrarAgregarUnidadesActivo.bind(this)}
          unidades={this.state.modalAgregarUnidadesActivoUnidades}
          cantidad={this.state.modalAgregarUnidadesActivoCantidad}
          insumo={this.state.modalAgregarUnidadesActivoInsumo}
        />
        <ModalEtiquetasActivosFijos
          visible={this.state.modalEtiquetasActivosVisible}
          entradaSalidaIds={this.state.entradaSalidaIdsEtiquetas}
          onCancel={this.cerrarModalEtiquetasActivos.bind(this)}
        />
        <ModalSplitInsumo
          visible={this.state.modalSplitVisible}
          onCancel={() => this.setState({ modalSplitVisible: false })}
          onOk={(partidas) => this.confirmarSplitInsumo(partidas)}
          proyectos={this.state.todasProyectos} // mismo arreglo que ya usas
          insumo={this.state.modalSplitInsumo} // insumo seleccionado
          cantidad={this.state.modalSplitCantidad} // cantidad a dividir
        />
        <DisponibilidadInsumoModal
          visible={this.state.modalDisponibilidadVisible}
          onClose={this.cerrarDisponibilidad}
          insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
          nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
        />
        <ModalDiagnosticoCuadre
          visible={this.state.modalDiagnosticoVisible}
          diagnostico={this.state.diagnostico}
          onCancel={() => this.setState({ modalDiagnosticoVisible: false })}
          onAplicarAjuste={() => {
            this.setState({ modalDiagnosticoVisible: false });
            this.ajustarTotalesAutomaticamente(this.state.ajusteContexto);
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permisoAccesoLeerXml:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "647a1df7bd6a695a9801702f"
      )?.activado,
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    taxidermia: state.empresa.taxidermia,
  };
};

export default connect(mapStateToProps)(AgregarFacturaCajaChica);
